import { useRouterState } from "@tanstack/react-router";
import { Link } from "@/components/catalyst/link";
import { UserCircleIcon } from "@heroicons/react/20/solid";
import { useOptionalUser } from "@/lib/Auth/useUser";
import { isProfileComplete } from "@/lib/Auth/profileCompleteness";

export function CompleteProfileBanner() {
  const user = useOptionalUser();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  if (isProfileComplete(user) || pathname.endsWith("/profile")) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-x-3 bg-indigo-600 px-6 py-2 sm:px-3.5">
      <UserCircleIcon className="h-4 w-4 text-white" />
      <p className="text-sm leading-6 text-white">
        <strong className="font-semibold">Finish your profile</strong> — add
        your name so your activity is attributed to you.
      </p>
      <Link
        from="/$tenant/$orgId/supplier/{-$supplierId}"
        to="/$tenant/$orgId/supplier/{-$supplierId}/profile"
        params={(prev) => prev}
        className="rounded-full bg-white/20 px-3 py-0.5 text-sm font-semibold text-white hover:bg-white/30"
      >
        Complete profile&nbsp;<span aria-hidden="true">&rarr;</span>
      </Link>
    </div>
  );
}
